import React, { useEffect, useState } from 'react';
import Select from "react-select";
const RegionList = ({region, saveRegionId, regs, id}) => {
  const [searchTerm, setSearchTerm] = useState({});
  const [reger, setReger] = useState([]);
  useEffect(() => {
    setReger(regs?.map(reg => {return {value: reg?.region_name, label: reg?.region_name, id: reg?.region_id}}));
  }, [regs])
  const handleInputChange = (opt) => {
    saveRegionId(opt?.id)
    setSearchTerm(opt);    
  };
  useEffect(() => {
    if(region === ""){
      setSearchTerm({value: "Yaoundé", label: "Yaoundé", id: 2})
    }else setSearchTerm({value: region, label: region, id: id})
  }, [region, id])
  
  return (
    <div style={{ width: "100%" }} className="user-country columnize" >

      <label htmlFor="city">Region: </label>
      <Select
        id="city"
        options={reger}
        value={searchTerm}
        onChange={handleInputChange}
        placeholder="region"
        styles={{
          menu: (base) => ({
            ...base,
            maxHeight: "150px",
            overflowY: "auto",  
          }),
          control: (base) => ({
            ...base,
            minHeight: "40px", 
          }),
          option: (base, { isSelected }) => ({
            ...base,
            padding: "8px 12px",
            backgroundColor: isSelected ? "#4CAF50" : "white",
            color: isSelected ? "white" : "black",
            ":hover": {
              backgroundColor: "#e0e0e0",
            },
          }),
        }}
        maxMenuHeight={150}
      />

    </div>
  );
};

export default RegionList;
